import { type TScreenName } from '../types/screenNameTypes'

import { getVisitedScreenForPath } from './currentScreen'

type TPendingSend = (screen: TScreenName) => void

// A soft-navigation metric arrives before the router publishes the new screen, so it waits for the
// path it belongs to instead of taking the screen we came from
const pending = new Map<string, TPendingSend[]>()

export const enqueuePerfMetric = (pathname: string, send: TPendingSend): void => {
    pending.set(pathname, [...(pending.get(pathname) ?? []), send])
}

export const flushPendingPerfMetrics = (): void => {
    if (pending.size === 0) {
        return
    }

    const queued = [...pending.entries()]

    pending.clear()

    queued.forEach(([pathname, sends]) => {
        const screen = getVisitedScreenForPath(pathname)

        sends.forEach(send => {
            send(screen)
        })
    })
}

if (typeof window !== 'undefined') {
    window.addEventListener('pagehide', () => {
        flushPendingPerfMetrics()
    })

    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
            flushPendingPerfMetrics()
        }
    })
}
